import {combineReducers} from "redux";
import Settings from "@/appRedux/reducers/Settings";
import Auth from "@/appRedux/reducers/Auth";
import Common from "@/appRedux/reducers/Common";
import SystemSetting from "@/appRedux/reducers/System";
import Translate from "@/appRedux/reducers/Translate";

import {connectRouter} from 'connected-react-router'

const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  common: Common,
  system: SystemSetting,
  translate: Translate,
});

export default createRootReducer;
